import {
    Col, Row, Container,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import useHtmlTitle from '../../../components/Utilities/useHtmlTitle';
import useBodyClass from '../../../components/Utilities/useBodyClass';
import useAccountContext from '../../../authentication/hooks';
import FormBanner from '../../../components/forms/FormBanner';
import HeaderIntroText from '../../../components/HeaderIntroText';
import { clearDashboardNotification } from '../../../storage/notification';

const AccountCreated = () => {
    const account = useAccountContext();

    useHtmlTitle('Account created successfully | NMI Services portal');
    useBodyClass('account-created');

    useEffect(() => {
        clearDashboardNotification();
    }, []);

    return (
        <>
            <FormBanner
                title='Create portal account'
                showSaveAndExitButton={false}
            />
            <Container fluid id='main' role='main' className='px-0' tabIndex={-1}>
                <Container className='py-5'>
                    <Row className='mb-5'>
                        <Col sm={12} md={10} lg={10} className='mx-auto'>
                            <h1 id='page-title' tabIndex={-1}>
                                {'Your portal account is ready, '}
                                {account?.details?.givenName !== undefined && (`${account?.details?.givenName}`)}
                            </h1>

                            <HeaderIntroText>
                                Thank you for creating your National Measurement Institute (NMI) Services portal account,
                                you can now create and manage services on the portal.
                                Continue by clicking &quot;Go to Services We Offer&quot; below.
                            </HeaderIntroText>
                            <div className='d-grid d-md-block'>
                                <Link
                                    data-testid='go-to-services-we-offer-button'
                                    to='/services-we-offer'
                                    className='btn btn-primary'
                                >
                                    Go to Services We Offer
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    );
};

export default AccountCreated;
